// src/pages/imamMahdi/ReflectionsStories.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ReflectionsStories = () => {
  return (
    <>
      <Helmet>
        <title>Reflections & Stories | Imam Mahdi (ajtf) | Ziyarat Guide</title>
        <meta
          name="description"
          content="Read touching reflections and real pilgrim stories about faith, hope, and connection with Imam Mahdi (ajtf). Explore diaries, poetry, and personal experiences from believers around the world."
        />
        <meta
          property="og:title"
          content="Reflections & Stories | Imam Mahdi (ajtf) | Ziyarat Guide"
        />
        <meta
          property="og:description"
          content="Personal reflections, pilgrim diaries, and heartfelt stories inspired by faith in Imam Mahdi (ajtf). A space for hope, devotion, and connection."
        />
        <meta
          property="og:image"
          content="https://ziyaratguide.com/static/media/ningth%20-%20How%20to%20talk%20to%20Imam%20Mahdi%20today%20.png"
        />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="imam-page">
        <div className="imam-content">
          <h1 className="page-title">Reflections & Stories</h1>

          <div className="content-section">
            <p>
              Perfect for your “Reflections & Stories” section — warm, personal, relatable.
            </p>

            <h2>Short Pilgrim Diaries</h2>
            <p>“Standing in Karbala, I felt my heart whisper to the Mahdi.”</p>

            <h2>Personal Struggles Turned into Prayers</h2>
            <p>
              “When I lost my job, I turned to Dua Nudba each Friday. It gave me
              strength to hope for a fairer world.”
            </p>

            <h2>Historical Stories</h2>
            <p>
              Moments when believers felt unseen help, attributing it to Imam
              Mahdi’s care.
            </p>

            <h2>Mini Interviews</h2>
            <p>
              “What does awaiting Imam Mahdi mean to you?” Ask scholars,
              ordinary people.
            </p>

            <h2>Poetic Pieces</h2>
            <p>
              “O Mahdi, we wait with lamps in hand — not to light the road for
              you, but to prove we’re ready to walk by your side.”
            </p>
          </div>
        </div>

        {/* Sidebar Navigation */}
        <aside className="imam-sidebar">
          <h2>Explore More</h2>
          <ul>
            <li>
              <Link to="/imam-mahdi">Who is Imam Mahdi?</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/described-in-quran-hadith">
                Described In Quran & Hadith
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/how-to-talk">How To Talk</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/impact-appearance">
                Impact of His Appearance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/misconceptions">Misconceptions</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/practices-allegiance">
                Practices & Allegiance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/reflections-stories">
                Reflections & Stories
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/return">Return</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/signs-reappearance">
                Signs of Reappearance
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/supporters">Supporters</Link>
            </li>
            <li>
              <Link to="/imam-mahdi/ultimate-reformer">
                The Ultimate Reformer
              </Link>
            </li>
            <li>
              <Link to="/imam-mahdi/why-occultation">Why Occultation</Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};

export default ReflectionsStories;
